<template>
  <div
    v-editable="props.blok"
    :data-uid="props.blok?._uid"
    class="tuev-widget"
    :class="{
      'without-criteria': props.blok?.criteria?.length === 0,
      'stand-alone': !props.blok?._uid
    }"
  >
    <figure>
      <NuxtLink
        to="https://www.tuv-saar.com/certificates/SC46133"
        target="_blank"
        title="Zum Testergebnis vom TÜV-Saarland"
        external
      >
        <LazyNuxtImg
          src="https://assets.pflege.de/f/167189/1772x932/7b6f36b7cd/tuv-siegel-2024.png"
          width="194"
          alt="TÜV bewertet pflege.de mit: Gut 1,9"
          format="webp"
        />
      </NuxtLink>
      <figcaption>
        <slot>Unsere Kundenzufriedenheit für die curabox<sup>®</sup> und den pflege.de-Anbietervergleich ist vom TÜV geprüft.</slot>
      </figcaption>
    </figure>
    <ul v-if="props.blok?.criteria?.length > 0">
      <li v-for="criteria in props.blok.criteria" :key="criteria" :class="{'special': CITERIAS[criteria]?.isSepcial}">
        <template v-if="CITERIAS[criteria]">
          <span>{{ CITERIAS[criteria].copy }}</span>
          <b><PflegeIcon name="success-fill" color="success" />&nbsp;{{ CITERIAS[criteria].mark }}</b>
        </template>
      </li>
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: false,
    default: new Object(),
  },
})

const CITERIAS = {
  quality: {
    copy: 'Qualität der angebotenen Produkte und Dienstleistungen',
    isSepcial: false,
    mark: '1,7',
  },
  communication: {
    copy: 'Verständliche und klare Kundenkommunikation',
    isSepcial: false,
    mark: '1,8',
  },
  service: {
    copy: 'Kundenservice insgesamt',
    isSepcial: false,
    mark: '1,7',
  },
  reliability: {
    copy: 'Zuverlässigkeit und Fairness des Unternehmens',
    isSepcial: false,
    mark: '1,6',
  },
  price: {
    copy: 'Preis-/ Leistungsverhältnis',
    isSepcial: false,
    mark: '1,8',
  },
  satisfaction: {
    copy: 'Gesamtzufriedenheit',
    isSepcial: true,
    mark: '1,9',
  },
  recommend: {
    copy: 'Weiterempfehlungsbereitschaft',
    isSepcial: true,
    mark: '80,6%',
  },
}
</script>

<style scoped>
.tuev-widget {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: center;
  font-size: 16px;
  padding-inline: 1rem;

  @media (width < 576px) {
    grid-template-columns: 1fr;
  }

  & figure {
    margin: 0;
    text-align: center;

    & img {
      max-width: 100%;
    }

    & figcaption {
      margin: .5rem auto 0;
      max-width: 30rem;
    }
  }

  & ul {
    display: grid;
    gap: .5em;
    list-style: none;
    margin: 0;
    padding: 0;

    & li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: .5rem;
      margin: 0;
      padding-inline: 1rem;
      padding-block: .5rem;
      background-color: var(--white);
      border-radius: .5rem;
      border: 1px solid var(--mint-dark);

      &.special {
        background-color: var(--mint-lighter);
        font-weight: 600;
      }

      & b {
        display: inline-flex;
        flex-shrink: 0;
      }
    }
  }

  &.without-criteria {
    grid-template-columns: 1fr;

    & figure {
      display: grid;
      grid-template-columns: auto 1fr;
      align-items: center;
      gap: .5rem;

      @media (width < 576px) {
        grid-template-columns: 1fr;
      }

      & figcaption {
        margin-top: 0;
      }
    }
  }

  &.stand-alone {
    grid-template-columns: 1fr;

    & figure figcaption {
      margin-top: 0;
    }
  }
}
</style>